import { Exploration } from '@/explore/types';

import {
  addJoinPipelineStepIds,
  convertJoinPipelineParametersToSteps,
} from './add-join-pipeline-step-ids';

// prettier-ignore
const Migrations = [
  convertJoinPipelineParametersToSteps,
  addJoinPipelineStepIds
];

export const migrateExploration = (exploration: Exploration): Exploration => {
  return Migrations.reduce((acc, migration) => migration(acc), exploration);
};
